export default __webpack_public_path__ + "static/media/area-chart.efe95ba8.svg";